import script from "./EditMenuPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditMenuPage.vue?vue&type=script&lang=ts&setup=true"

import "./EditMenuPage.vue?vue&type=style&index=0&id=303be370&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-303be370"]])

export default __exports__